import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-leave-org-modal',
  standalone: true,
  imports: [],
  templateUrl: './leave-org-modal.component.html',
  styleUrl: './leave-org-modal.component.scss',
})
export class LeaveOrgModalComponent {
  @Input() orgName: string;
  @Input() isFromSubOrgPage: boolean;
}
